module.exports = __webpack_public_path__ + "img/AvatarGolzo.c0966653.jpeg";